module.exports = __webpack_public_path__ + "37025e3ffd3fdb970292eca0ffc9c3b7.png";